import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/guider")({
  component: () => <Outlet />,
});
